export const ReportsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M5 20h14a1 1 0 0 0 1-1V9.5l-7-5-7 5V19a1 1 0 0 0 1 1zm2-2V11.3l5-3.57 5 3.57V18H7zm2-8h6v2H9V10zm0 4h6v2H9v-2z"
      fill="#cfd1dc"
    />
  </svg>
);
